import { HTMLLink } from "../objects/HTMLLink";
export const LOGGED_IN_URL = `home`

export const links = [
  new HTMLLink( `Docs`, `/docs`, true ),
  // new HTMLLink( `Drawer`, `/drawer-test`, true ),
  // new HTMLLink( `Billing`, `/${LOGGED_IN_URL}/billing`, true ),
  // new HTMLLink( `Account`, `/${LOGGED_IN_URL}/account`, true ),
]